<template>

<div class="mark">
	<div class="mark-circle">
		<img src="../assets/gg.svg" alt="" aria-hidden="true" />
	</div>
	<div class="mark-name">geek<span>group</span></div>
</div>

</template>

<script>

// The standard header lockup (rocket in a dark circle + the geekgroup
// wordmark), shown at the top of every authorize stage.
export default {
	name: 'Mark'
}

</script>

<style scoped>

.mark {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mark-circle {
	width: 104px;
	height: 104px;
	border-radius: 50%;
	background: #04141c;
	display: flex;
	align-items: center;
	justify-content: center;
}

.mark-circle img { width: 58px; height: 58px; display: block; }

.mark-name {
	font-family: 'Barlow', sans-serif;
	font-weight: 700;
	font-size: 34px;
	letter-spacing: 1.5px;
	line-height: 1;
	color: #fff;
	margin-top: 18px;
}

.mark-name span { color: #ffc563; }

</style>
